<h4>{{ "CONFIG.misc.header" | translate }}</h4>
<nav mat-tab-nav-bar mat-stretch-tabs="false" [tabPanel]="tabPanel">
  <a mat-tab-link routerLink="general" [active]="isActive('general')">
    General
  </a>
  <a mat-tab-link routerLink="status-events" [active]="isActive('status-events')">
    {{ 'NAVBAR.system_events' | translate }}
  </a>
  <a mat-tab-link routerLink="targets" [active]="isActive('targets')">
    Target
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <div class="container d-flex flex-column justify-content-center align-items-center pt-2">
    <div class="col-12">
      <div class="card shadow">
        <div class="card-body pt-5">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</mat-tab-nav-panel>
